import Vue from 'vue'
import Router from 'vue-router'
import beforeEnter from '@/utils'

const LoginPage = () => import('@/pages/LoginPage')
const DefaultLayout = () => import('@/layouts/DefaultLayout')
const TimesheetAddPage = () => import('@/pages/timesheet/TimesheetAddPage')

const NotFoundPage = () => import('@/pages/NotFoundPage.vue')

Vue.use(Router)

export default new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    linkExactActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: [
        {
            path: '/',
            name: 'Home',
            redirect: '/timesheet',
            component: DefaultLayout,
            beforeEnter: beforeEnter,
            children: [
              {
                path: 'timesheet',
                name: 'Timesheet',
                redirect: '/timesheet/add',
                beforeEnter: beforeEnter,
                component: {
                  render(c) {
                    return c('router-view')
                  }
                },
                children: [
                  {
                    path: 'add',
                    name: 'TimesheetAdd',
                    component: TimesheetAddPage
                  }
                ]
              }
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: LoginPage
        },
        {
            path: '/404',
            name: 'NotFound',
            component: NotFoundPage
        },
        {
            path: '*',
            component: NotFoundPage
        }
    ]
})
